import React, { useState, FormEvent } from 'react';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from '../../redux/rootReducer';
import { resetPassword } from '../../redux/slices/authSlice';
import Card from 'react-bootstrap/Card';
import Button from '../atoms/Button';
import { Container } from 'react-bootstrap';
import InputField from '../atoms/InputField';

function ResetPassword() {
  const dispatch = useDispatch<ThunkDispatch<RootState, void, any>>();
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);

  const handleReset = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    
    try {
      await dispatch(resetPassword(email || undefined));
      // If successful, user will be redirected to Auth0 password reset page
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to initiate password reset');
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <br />
      <Card style={{ width: '18rem', margin: '0 auto' }}>
        <Card.Body>
          <Card.Title>Reset Password</Card.Title>
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          <form onSubmit={handleReset}>
            <InputField
              label="Email"
              type="email"
              name="email"
              value={email}
              placeholder="Enter your email"
              required
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button 
              className="btn btn-primary w-100" 
              type="submit"
              disabled={isLoading}
              text={isLoading ? "Processing..." : "Reset Password"}
            />
          </form>
          <div className="mt-3 text-center">
            <a href="/login">Back to Login</a>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default ResetPassword;